export const STEP_LIMIT = 20;
export const RERENDER_INTERVALL_MS = 60000;
